import {
  ChatMessageListItem,
  IChatConversation,
  LastReadMessageSocketType,
} from 'src/@types/chat';
import { addListener } from '../common';

export const onChatNewChannel =
  addListener<IChatConversation>('/chat/channel/new');
export const onChatChannelUpdate = addListener<IChatConversation>(
  '/chat/channel/update',
);
export const onChatChannelDelete = addListener<IChatConversation>(
  '/chat/channel/delete',
);

export const onChatNewMessage =
  addListener<ChatMessageListItem>('/chat/message/new');
export const onUpdateMessage = addListener<ChatMessageListItem>(
  '/chat/message/update',
);
export const onDeleteMessage = addListener<ChatMessageListItem>(
  '/chat/message/delete',
);
export const onPinMessage = addListener<ChatMessageListItem>(
  '/chat/message/set-pinned',
);

export const onReadMessage = addListener<LastReadMessageSocketType>(
  '/chat/message/read-messages',
);
